export const get = <T>(field: string): T|undefined => {
	const result = window.sessionStorage.getItem(field);
	return result ? JSON.parse(result) : undefined;
};

export const set = <T>(field: string, data: T) => {
	window.sessionStorage.setItem(field, JSON.stringify(data));
};

export const remove = (field: string) => {
	window.sessionStorage.removeItem(field);
};